<template>
  <div>
    <EventDetails
      :should-add-event-schema="true"
      :event-permalink="$route.params.eventPermalink.toString()"
      :is-giftcard="false"
    ></EventDetails>
  </div>
</template>

<script lang="ts" setup>
definePageMeta({
  // name: 'event-details-page', // explicit naming requires more attention with localization
  allowOnPartnerPage: true,
  contentGroup: 'event',
  layout: 'default-max-screen',
  preloaderType: 'eventDetail',
})
</script>
